'use strict'; /* eslint-disable no-console */

import _ from 'lodash';

const navigation = (function() {
	let currentPath;
	let navToggle;
	let mainNav;
	let mainNavPrimary;
	let mainNavLinks;
	let panelToggle;
	let activeClass = 'active';
	let jsActiveClass = 'js-is-active';
	let bodyNavClass = 'js-nav-open';
	let desktopSize = '(min-width: 992px)';
	// let desktopSize = '(min-width: 769px)';
	let isNavOpen = false;
	let isDesktopSize = false;
	let threshold = 480;
	let scrolledClass = 'js-is-scrolled';
	let stickyClass = 'js-is-showing';
	let header;
	let isScrolled = false;
	let lastScrollTop;
	let body;
	let currentScrollPosition = 0;



	/*
	* getScrollPosition()
	*
	* get the current scroll position;
	*/
	function getScrollPosition() {
		return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	}



	/*
	* setScrollPosition()
	*
	* @param pos - int: set the current scroll position to this number
	*/
	function setScrollPosition( pos ) {
		document.body.scrollTop = pos;

	}



	/*
	* openNav()
	*
	* close the main nav - add fixed position class on the body
	*/
	function openNav() {
		// if mobile, save the current scroll position
		// before doing any of the opening tasks
		if( !matchMedia(desktopSize).matches){
			currentScrollPosition = getScrollPosition();
			console.log('current scroll', currentScrollPosition);
		}
		navToggle.setAttribute('aria-expanded', 'true');
		mainNav.setAttribute('aria-hidden', 'false');
		mainNav.classList.add(jsActiveClass);

		// don't add fixed position to the body when resizing to
		// desktop.
		if( !matchMedia(desktopSize).matches){
			body.classList.add(bodyNavClass);
		}

		isNavOpen = true;
	}



	/*
	* closeNav()
	*
	* close the main nav - remove fixed position class on the body
	*/
	function closeNav(setScroll = true) {
		// console.log('close nav');
		navToggle.setAttribute('aria-expanded', 'false');
		mainNav.setAttribute('aria-hidden', 'true');
		mainNav.classList.remove(jsActiveClass);

		// remove this regardless of viewport width
		body.classList.remove(bodyNavClass);


		// only reset the scroll offset it if mobile
		if( !matchMedia(desktopSize).matches && setScroll ){
			// console.log('isResizing', isResizing);
			setScrollPosition( currentScrollPosition );
		}


		isNavOpen = false;
	}




	/*
	* toggleNav()
	*
	* open or close the main nav
	*/
	function toggleNav() {
		if( !mainNav.classList.contains(jsActiveClass) ) {
			openNav();
		}else{
			closeNav();
		}
	}



	/*
	* doAccessibility()
	*
	* attach aria attributes to the main nav and its toggle control
	*/
	function doAccessibility() {
		navToggle.setAttribute('aria-expanded', 'false');
		mainNav.setAttribute('aria-hidden', 'true');
		mainNav.setAttribute('aria-labelledby', navToggle.id);
	}



	/*
	* resizeHandler()
	*
	* opens nav if set to closed while resizing to desktop from
	* mobile size.
	*/
	function resizeHandler() {
		// currentScrollPosition = getScrollPosition();
		// console.log('resized');
		if(window.matchMedia(desktopSize).matches){
			// desktop
			if( !isNavOpen ){
				openNav();
			}
			header.classList.remove(stickyClass);
			isDesktopSize = true;
		}else{
			// small screen
			// isDesktopSize flag is used to prevent closing the nav
			// when resizing the screen while the nav is open on
			// small size screens
			if( isNavOpen && isDesktopSize ){
				closeNav(false);
			}
			isDesktopSize = false;
		}
	}


	/*
	* closePanel()
	*
	* @param panel - DOM el: panel that is to be closed
	* @param toggler - DOM el: element that invokes this function
	*/
	function closePanel(panel, toggler) {
		// console.log('close panel');
		toggler.setAttribute('aria-expanded', 'false');
		panel.setAttribute('aria-hidden', 'true');
		panel.classList.remove(jsActiveClass);
		mainNavPrimary.classList.remove('js-panel-open');
	}



	/*
	* openPanel()
	*
	* @param panel - DOM el: panel that is to be opened
	* @param toggler - DOM el: element that invokes this function
	*/
	function openPanel(panel, toggler) {
		// console.log('open panel');
		toggler.setAttribute('aria-expanded', 'true');
		panel.setAttribute('aria-hidden', 'false');
		panel.classList.add(jsActiveClass);
		mainNavPrimary.classList.add('js-panel-open');
	}



	/*
	* togglePanel()
	*
	* available for mobile only, toggles panels inside nav
	*
	* @param e - click event
	*/
	function togglePanel(e) {
		// only toggle panels on mobile size
		if( !matchMedia(desktopSize).matches ){
			e.preventDefault();
			const toggler = e.currentTarget
			const target = document.getElementById(toggler.dataset.target);

			if( !target.classList.contains(jsActiveClass) ){
				openPanel(target, toggler);
			}else{
				closePanel(target, toggler);
			}
		}
	}




	// function checkFixed() {
	// 	let isFixed = (body.classList.contains(stickyClass) ) ? true : false;
	// 	return isFixed;
	// }



	/*
	* detectScrollDirection()
	*
	* available for mobile only, toggles panels inside nav
	*
	* @param e - click event
	*/
	function detectScrollDirection(onPageWithNav, mobileNav) {
		let scrolled = getScrollPosition();

		if (scrolled > lastScrollTop){
			// downscroll code
			header.classList.remove(stickyClass);
			if (onPageWithNav) {
				mobileNav.classList.remove(stickyClass);
			}
		} else if (scrolled < threshold) {
			// upscroll code
			header.classList.add(stickyClass);
		} else {
			if (onPageWithNav) {
				mobileNav.classList.add(stickyClass);
			}
		}
		lastScrollTop = scrolled;
	}



	/*
	* scrollHandler() -
	*
	* listens to scroll event to apply fixed positioning and hide/show of header
	*/
	function scrollHandler(onPageWithNav, mobileNav) {
			// console.log('scrolling');
			let scrolled = getScrollPosition();
			// console.log(scrolled);
			// currentScrollPosition = scrolled;

			if( scrolled > threshold ) {
				// set scrolled flag for checking scroll direction below
				isScrolled = true;
				header.classList.add(scrolledClass);
				if (onPageWithNav) {
					mobileNav.classList.add(scrolledClass);
				}
			}else{
				// unset scrolled flag for checking scroll direction below
				isScrolled = false;

				// console.log('not fixed');
				// if( !checkFixed() ){
					// console.log('fixed, removing');
				header.classList.remove(scrolledClass);
				if (onPageWithNav) {
					mobileNav.classList.remove(scrolledClass);
				}
				// }
			}

			// if we are scrolling, check for direction
			// to show on scroll up, and hide for
			// scroll down
			if( !matchMedia(desktopSize).matches ){
				if( isScrolled ){
					detectScrollDirection(onPageWithNav, mobileNav);
				}
			}
	}



	/*
	* addEventListeners()
	*
	* called on init - attaches event listeners if the
	* needed DOM elements are present
	*/
	function addEventListeners(onPageWithNav, mobileNav) {
		// init click listener
		navToggle.addEventListener('click', toggleNav);

		// add event listeners to panel toggles
		[].forEach.call(panelToggle, (toggle) => {
			toggle.addEventListener('click', togglePanel);
		});

		// add aria
		doAccessibility();

		// listen to resize event to toggle nav
		window.addEventListener('resize', _.throttle(resizeHandler, 100));

		// listen to scroll event for sticky navigation
		window.addEventListener('scroll', _.throttle(() => scrollHandler(onPageWithNav, mobileNav), 100));

		scrollHandler(onPageWithNav, mobileNav);
		resizeHandler();
	}

	/*
	 * activeNavigation()
	 *
	 * add active class to main nav link if it matches the current page
	 *
	 * @param mainNavLinks - main nav links collection
	 * @param currentPath - current URL path
	 */
	function activeNavigation(mainNavLinks, currentPath) {
		[].forEach.call(mainNavLinks,(link) => {
			const navLinkHref = link.getElementsByTagName('a')[0];
			let hrefValue = navLinkHref.getAttribute('href');
			hrefValue = `/${hrefValue.split('/')[1]}`;
			const pathMatch = hrefValue.indexOf(currentPath) !== -1;
			if (pathMatch && currentPath !== '/') {
				link.classList.add(activeClass);
			}
		});
	}

	/*
	* init()
	*
	* called on DOMContentLoaded event - assigns variables and calls event listenrs
	*/
	function init(onPageWithNav, mobileNav) {
		// assign variables
		currentPath = `/${location.pathname.split('/')[1]}`;
		navToggle = document.getElementById('js-toggle-nav');
		mainNav = document.querySelector('.main-nav');
		mainNavPrimary = document.querySelector('.main-nav__primary');
		mainNavLinks = document.querySelectorAll('.main-nav__link');
		panelToggle = document.querySelectorAll('.js-toggle-panel');
		header = document.querySelector('.main-header');
		body = document.body;
		lastScrollTop = getScrollPosition();

		activeNavigation(mainNavLinks, currentPath);

		if( navToggle ){
			addEventListeners(onPageWithNav, mobileNav);
		}
	}

	window.addEventListener('DOMContentLoaded', () => {
		const isResourcesPage = window.location.pathname.indexOf('/resources') !== -1;
		const isDashboardPage = (window.location.pathname.indexOf('/static/dashboard') !== -1) || (window.location.pathname.indexOf('/customer/') !== -1) ? true : false;
		let resourcesNavMobile;
		let dashboardNavMobile;

		if (isResourcesPage) {
			resourcesNavMobile = document.querySelector('.resources__nav');
			init(isResourcesPage, resourcesNavMobile);
		} else if (isDashboardPage) {
			dashboardNavMobile = document.querySelector('.dashboard-nav');
			init(isDashboardPage, dashboardNavMobile);
		} else {
			init();
		}
	});
})();

export default navigation;



// WEBPACK FOOTER //
// ./resources/assets/js/navigation.js